import * as fromDatatype from "../datatype-library/index";

export interface bl_hr_org_chart_hierarchy_node_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  org_chart_hdr_guid: fromDatatype.GuidDataFieldInterface;
  child_guids: fromDatatype.TextDatatypeInterface;
  type: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  rank: fromDatatype.IntegerDatatypeInterface;
  designation: fromDatatype.VarcharDatatypeInterface;
  job_title: fromDatatype.VarcharDatatypeInterface;
  position_name: fromDatatype.VarcharDatatypeInterface;
  report_to_guid: fromDatatype.GuidDataFieldInterface;
  report_to_name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_hr_org_chart_hierarchy_node_hdr_RowClass
  implements bl_hr_org_chart_hierarchy_node_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  org_chart_hdr_guid: fromDatatype.GuidDataFieldInterface;
  child_guids: fromDatatype.TextDatatypeInterface;
  type: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  rank: fromDatatype.IntegerDatatypeInterface;
  designation: fromDatatype.VarcharDatatypeInterface;
  job_title: fromDatatype.VarcharDatatypeInterface;
  position_name: fromDatatype.VarcharDatatypeInterface;
  report_to_guid: fromDatatype.GuidDataFieldInterface;
  report_to_name: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
